import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
// material
import { Box, FormControlLabel, Checkbox } from '@material-ui/core';

// ----------------------------------------------------------------------
IconColor.propTypes = {
  sx: PropTypes.object,
  color: PropTypes.string.isRequired,
  isSelected: PropTypes.bool
};

function IconColor({ sx, color, isSelected, ...other }) {
  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        display: 'flex',
        borderRadius: '50%',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: color,
        transition: (theme) =>
          theme.transitions.create('all', {
            duration: theme.transitions.duration.shortest
          }),
        border: `2px solid ${color}`,
        ...sx
      }}
      {...other}
    >
      {isSelected && <Icon icon={checkmarkFill} style={{ color: 'white' }} />}
    </Box>
  );
}

ColorTagMultiPicker.propTypes = {
  colors: PropTypes.array.isRequired,
  selectedColors: PropTypes.array,
  onChange: PropTypes.func.isRequired
};

export default function ColorTagMultiPicker({ colors, selectedColors = [], onChange, ...other }) {
  const handleToggle = (selectedTag) => {
    const isSelected = selectedColors.some((color) => color.id === selectedTag.id);

    if (isSelected) {
      onChange(selectedColors.filter((color) => color.id !== selectedTag.id));
    } else {
      onChange([...selectedColors, selectedTag]);
    }
  };

  return (
    <Box row {...other}>
      {colors.map((tag, index) => {
        const isWhite = tag.color === '#FFFFFF' || tag.color === 'white';
        const isSelected = selectedColors.some((color) => color.id === tag.id);

        return (
          <FormControlLabel
            key={index}
            value={tag.color}
            label={tag.tag}
            control={
              <Checkbox
                checked={isSelected}
                onChange={() => handleToggle(tag)}
                icon={
                  <IconColor
                    color={tag.color}
                    isSelected={false}
                    sx={{
                      ...(isWhite && {
                        border: (theme) => `solid 1px ${theme.palette.divider}`
                      })
                    }}
                  />
                }
                checkedIcon={
                  <IconColor
                    color={tag.color}
                    isSelected
                    sx={{
                      transform: 'scale(1.4)',
                      '&:before': {
                        opacity: 0.48,
                        width: '100%',
                        content: "''",
                        height: '100%',
                        borderRadius: '50%',
                        position: 'absolute',
                        boxShadow: `4px 4px 8px 0 ${tag.color}`
                      },
                      '& svg': { width: 12, height: 12, color: 'common.white' },
                      ...(isWhite && {
                        border: (theme) => `solid 1px ${theme.palette.divider}`,
                        boxShadow: (theme) => `4px 4px 8px 0 ${theme.palette.grey[500_24]}`,
                        '& svg': { width: 12, height: 12, color: 'common.black' }
                      })
                    }}
                  />
                }
                sx={{
                  color: tag.color,
                  '&:hover': { opacity: 0.72 }
                }}
              />
            }
          />
        );
      })}
    </Box>
  );
}
